import {produce} from "immer";
import {Store} from "reducers/rootReducer";
import {PortalFields} from "components/LeftMenu/LeftMenuLinks/models";
import {SIGN_OUT} from "reducers/auth";

export type PortalConfigurationDetails = {
  bUsesClientPortalConfiguration: boolean;
  bDashboardVisible: boolean;
  bReviewFeedVisible: boolean;
  bReviewConsolidationVisible: boolean;
  bLeagueTablesVisible: boolean;
  bLoginReportVisible: boolean;
  bQuicksightVisible: boolean;
  bPrintPdfVisible: boolean;
  PrintPdfCustomName: string | null;
  DashboardCustomName: string | null;
  ReviewFeedCustomName: string | null;
  ReviewConsolidationCustomName: string | null;
  CommentAnalysisCustomName: string | null;
  LeagueTablesCustomName: string | null;
  LoginReportCustomName: string | null;
  DownloadsCustomName: string | null;
  GeneralPortalConfiguration: string;
  DashboardConfiguration: string;
  PrintPdfConfiguration: string;
  ReviewFeedConfiguration: string;
  ReviewConsolidationConfiguration: string;
  CommentAnalysisConfiguration: string;
  LeagueTablesConfiguration: string;
  LoginReportConfiguration: string;
  DownloadsConfiguration: string;
};

/* STATE */
type State = {
  portalConfigurationDetails: null | PortalConfigurationDetails;
  portalData: PortalFields | null;
};

const initialState: State = {
  portalConfigurationDetails: null,
  portalData: null,
};

/* ACTIONS */
const SET_PORTAL_CONFIG = "app/configuration/SET_PORTAL_CONFIG";
const SET_PORTAL_DATA = "app/configuration/SET_PORTAL_DATA";
const CLEAR_ALL_DATA = "app/configuration/CLEAR_ALL_DATA";

type Action =
  | {
      type: typeof SET_PORTAL_CONFIG;
      payload: null | PortalConfigurationDetails;
    }
  | { type: typeof SET_PORTAL_DATA; payload: null | PortalFields }
  | { type: typeof CLEAR_ALL_DATA }
  | { type: typeof SIGN_OUT };

/* REDUCER */
export default function reducer(state = initialState, action: Action): State {
  return produce(state, (draft) => {
    switch (action.type) {
      case SET_PORTAL_CONFIG:
        draft.portalConfigurationDetails = action.payload;
        break;
      case SET_PORTAL_DATA:
        draft.portalData = action.payload;
        break;
      case CLEAR_ALL_DATA:
        draft.portalConfigurationDetails = initialState.portalConfigurationDetails;
        draft.portalData = initialState.portalData;
        break;
      case SIGN_OUT:
        return initialState;
    }
  });
}

/* ACTION CREATORS */
export const setPortalConfig = (payload: null | PortalConfigurationDetails): Action => ({
  type: SET_PORTAL_CONFIG,
  payload,
});

export const setPortalData = (payload: null | PortalFields): Action => ({
  type: SET_PORTAL_DATA,
  payload,
});

export const clearPortalData = (): Action => ({
  type: CLEAR_ALL_DATA,
});

/* SELECTORS */
export const selectPortalConfig = (app: Store) => app.configuration.portalConfigurationDetails;

export const selectPortalData = (app: Store) => app.configuration.portalData;
